module.exports = __webpack_public_path__ + "097728cc11419006cc002bfac51e918b.jpg";